<div class="w-full h-full p-1">
	<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
		@if (configMissing) {
			<p-dialog [draggable]="false" [visible]="disabledMessage != null" [closable]="false" appendTo="self">
				<i class="pi pi-exclamation-circle pr-1"></i>
				<label>{{ disabledMessage }}</label>
				<br />
				<br />
			</p-dialog>
		} @else if (postYieldForm) {
			<form [formGroup]="postYieldForm" class="flex flex-col gap-3">
				<div formGroupName="postYieldAnalsisParameters" class="w-full">
					<div class="field">
						<label for="hollidayStressRatio">Critical Holliday Stress Ratio</label>
						<span class="pl-1">
							<i pTooltip="Von Mises stress divided by the temperature-derated yield strength. Use 1.0 for working stress design, or the higher allowable value your design basis permits for ductile grade thermal service." class="pi pi-info-circle cursor-help relative z-[2]"></i>
						</span>
					</div>
					<app-validated-number-input
						[id]="'hollidayStressRatio'"
						[control]="hollidayStressRatioControl"
						[value]="hollidayStressRatioControl.value"
						[validation]="hollidayStressRatioValidation"
                    ></app-validated-number-input>
				</div>
			</form>
		}
	</app-tool-loader>
</div>
